module.exports = __webpack_public_path__ + "img/mail.c2e0a9d0.svg";